import React, { useState } from 'react';
import { Icons } from '@citygross/icons';
import { Container, StepButton, Label, Input } from './QuantitySelector.styles.js';
import { theme } from '@citygross/design-tokens';
import { EQuantitySelectorSize } from './QuantitySelector.types.js';

function QuantitySelector(_a) {
  var _b, _c, _d, _e;

  var maxQuantity = _a.maxQuantity,
      onAdd = _a.onAdd,
      onBlur = _a.onBlur,
      _onChange = _a.onChange,
      onSubtract = _a.onSubtract,
      productName = _a.productName,
      quantity = _a.quantity,
      _f = _a.size,
      size = _f === void 0 ? EQuantitySelectorSize.large : _f;

  var _g = useState(false),
      isFocused = _g[0],
      setIsFocused = _g[1];

  var disabledAdd = quantity >= maxQuantity;
  var disabledSubtract = quantity <= 0;

  var handleBlur = function handleBlur() {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === ',' || e.key === '.') e.preventDefault();
    if (e.key === 'Enter' || e.key === 'Escape') e.currentTarget.blur();
  };

  return React.createElement(Container, {
    size: size
  }, React.createElement(StepButton, {
    "aria-label": "Minska antal ".concat(productName || ''),
    direction: "subtract",
    disabled: disabledSubtract,
    onClick: onSubtract
  }, React.createElement(Icons.Minus, {
    color: disabledSubtract ? (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.placeholder : (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.darkest,
    height: 16,
    width: 16
  })), React.createElement(Label, null, quantity === maxQuantity && !isFocused && React.createElement("span", {
    "aria-label": "Max antal ".concat(maxQuantity),
    "aria-live": "polite",
    role: "status"
  }, "Max"), React.createElement(Input, {
    "aria-label": "Ange antal",
    id: "quantity-input",
    inputMode: "numeric",
    isMaxQuantity: quantity === maxQuantity && !isFocused,
    max: maxQuantity,
    min: 0,
    onBlur: handleBlur,
    onChange: function onChange(e) {
      return _onChange(e);
    },
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onKeyDown: handleKeyDown,
    pattern: "[0-9]*",
    type: "number",
    value: quantity
  })), React.createElement(StepButton, {
    "aria-label": "\xD6ka antal ".concat(productName || ''),
    direction: "add",
    disabled: disabledAdd,
    onClick: onAdd
  }, React.createElement(Icons.Plus, {
    color: disabledAdd ? (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.placeholder : (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.darkest,
    height: 16,
    width: 16
  })));
}

export { QuantitySelector };